export class AngularComboItem {
    value: string;
    descrizione: string;
    selected:boolean;    
    static generate = function(listaValori: any[], valueFieldName: string, descriptionFieldName: string, firstValue?: string, firstDescription?: string){
        let items = new Array<AngularComboItem>();
        if(firstValue != undefined && firstDescription != undefined) {
            let i = new AngularComboItem();
            i.value = firstValue;
            i.descrizione = firstDescription;
            items.push(i);
        }
        if(listaValori && listaValori.length > 0) {
            listaValori.forEach(element => {
                let i = new AngularComboItem();
                i.value = element[valueFieldName];
                i.descrizione = element[descriptionFieldName];
                items.push(i);
            });
        }
        return items;
    }    
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-combo-item.ts